import { Route } from '~/Constants/Routes.constants';
import { useNavigation } from '~/Hooks';
import { IEvent } from '~/Models/DTO/Event.model';

export const useCalendarEvent = ({ event }: { event: Partial<IEvent> }) => {
  const { navigate } = useNavigation();
  const goToDetail = () =>
    event.id &&
    event.type &&
    navigate(Route.EVENT_DETAILS, { id: event.id, eventType: event.type });

  return {
    goToDetail,
  };
};
